import { z } from 'zod';

/**
 * Shared Zod schemas for provider friendly feedback.
 *
 * These schemas describe the JSONB payload stored in
 * `provider_performance_scores.friendly_feedback` and returned by the
 * Platform AI `/friendly-feedback` endpoint.
 *
 * Used by both web-app (tRPC output validation) and worker (job processing).
 */

export const strengthItemSchema = z.object({
  title: z.string(),
  content: z.string(),
});

export const experimentItemSchema = z.object({
  title: z.string(),
  evidence: z.string(),
  suggestion: z.string(),
});

export const focusAreaSchema = z.object({
  category: z.string(),
  experiments: z.array(experimentItemSchema),
});

export const friendlyFeedbackSchema = z.object({
  what_went_well: z.array(strengthItemSchema),
  focus_areas: z.array(focusAreaSchema),
});

export type FriendlyFeedback = z.infer<typeof friendlyFeedbackSchema>;
export type StrengthItem = z.infer<typeof strengthItemSchema>;
export type ExperimentItem = z.infer<typeof experimentItemSchema>;
export type FocusAreaItem = z.infer<typeof focusAreaSchema>;
